// ESSE CÓDIGO É ADICIONADO NO FINAL DO ARQUIVO product-form.js

// =======================================
// FABRIC ENTERPRISE BRIDGE (PUBLIC API)
// =======================================

window.FabricBridge = window.FabricBridge || {};

/**
 * Atualiza o estado global do carrinho
 * (contador, seções, listeners do tema)
 */
window.FabricBridge.refreshCart = async () => {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    document.dispatchEvent(
      new CartUpdateEvent(cart, {
        source: 'fabric-bridge'
      })
    );

    return cart;
  } catch (err) {
    console.error('[FabricBridge] Failed to refresh cart', err);
  }
};

/**
 * Abre o carrinho lateral usando
 * o fluxo NATIVO do Fabric
 */
window.FabricBridge.openCartDrawer = () => {
  // O Fabric abre o drawer quando um CartAddEvent é disparado
  document.dispatchEvent(
    new CartAddEvent(
      {},
      'fabric-bridge',
      {
        source: 'fabric-bridge',
        openDrawer: true
      }
    )
  );
};